import { render, staticRenderFns } from "./StoriesModalSlider.vue?vue&type=template&id=295df5a0&scoped=true"
import script from "./StoriesModalSlider.vue?vue&type=script&lang=ts"
export * from "./StoriesModalSlider.vue?vue&type=script&lang=ts"
import style0 from "./StoriesModalSlider.vue?vue&type=style&index=0&id=295df5a0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295df5a0",
  null
  
)

export default component.exports